module.exports = __webpack_public_path__ + "img/mg.8918cf47.jpg";